<template>
  <div>
    <Modal
      v-model="modal"
      :closable="false"
      footer-hide
      class="hesuanModal"
      :mask-closable="false"
      width="460"
    >
      <div style="text-align:left">
        <div class="hesuan-content">
          <div
            style="box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);    width: 70px;
    height: 70px;
    vertical-align: top;
    background: #fff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    float: left;"
    
    
          >
            <img src="@/assets/img/icon_file.png"  alt />
          </div>
          <div style=" margin-left: 100px;">
            <span
            class="text-hide"
              style="display: block; font-size: 15px; font-weight: bold; margin: 10px 0px;"
            >{{fileName}} </span>
            <span>{{ $t("global.imports_loading") }}...</span>
          </div>
        </div>
        <div class="pl-20 pb-20">
          <Progress style="width: 100%" :percent="percent" />
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      file: "excel",
      modal: false,
      percent: 0,
      fileName: null
    };
  },
  methods: {
    //模板導出
    async export_template(url, parmars, fileName, file, mode, is_att) {
      try {
        this.modal = true;
        this.fileName = fileName;
        this.file = file ? file : "excel";
        this.percent = 40;
        const res = await this.$http(
          mode ? mode : "post",
          url,
          parmars,
          true,
          is_att,
          "arraybuffer"
        );
        const t1 = setInterval(() => {
          this.percent += 20;
          if (this.percent >= 100) {
            clearInterval(t1);
            this.modal = false;
            let blob = new Blob([res.data], {
              type:
                "application/vnd.ms-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            this.setEexlFileName(
              blob,
              `${fileName}.${file === "excel" ? "xlsx" : file}`
            );
          }
        }, 100);
      } catch (e) {
        this.modal = false;
      }
    },
    async download(url, fileName, file, mode, parmas) {
      let is_http = _.isArray(url.split(":")) ? url.split(":")[0] : null;

      try {
        this.modal = true;
        this.fileName = fileName;
        this.file = file ? file : "Files";
        this.percent = 40;
        let res;
        if (is_http === "https") {
          res = await axios({
            method: mode ? mode : "get",
            url: url,

            data: parmas ? parmas : {},
            responseType: "blob"
          });
        } else {
          res = await this.$http(
            mode ? mode : "get",
            url,
            parmas ? parmas : {},
            true,
            null,
            "blob"
          );
        }
        const t1 = setInterval(() => {
          this.percent += 20;
          if (this.percent >= 100) {
            clearInterval(t1);
            this.modal = false;
            this.setEexlFileName(
              res.data,
              !file ? fileName : `${fileName}.${file}`
            );
          }
        }, 100);
      } catch (e) {
        this.modal = false;
      }
    },
    setEexlFileName(blob, fileName) {
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, fileName);
      } else {
        let URL = window.URL || window.webkitURL;
        let objectUrl = URL.createObjectURL(blob);
        if (fileName) {
          let a = document.createElement("a");
          if (typeof a.download === "undefined") {
            window.location = objectUrl;
          } else {
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(objectUrl);
            document.body.removeChild(a);
          }
        } else {
          window.location = objectUrl;
        }
        URL.revokeObjectURL(objectUrl);
      }
    }
  }
};
</script>